export const TEMPLATES = [
  {
    key: "christmas", label: "Christmas shop is open",
    subject: "Our Christmas shop is open - luxury treats for the festive season",
    body: `The festive shelves are stocked! Our Christmas shop is now open, filled with luxury chocolate, beautiful biscuit tins and selection boxes hand-picked from Marks & Spencer, Waitrose and more.

New this year: build your own Gift Hamper with your favourite treats, finished with gift wrapping and a handwritten message card.

Christmas delivery: order by the last posting dates shown on our website to make sure your parcel arrives in time. Popular tins sell out quickly, so don't leave it too late.

Wishing you a very merry Christmas,
The Albion Pantry team`,
  },
  {
    key: "christmas_last", label: "Last Christmas posting days",
    subject: "Last few days to order for Christmas delivery",
    body: `Time is running out! The last posting dates for Christmas delivery with Evri are almost here.

If you still have a gift to find, our Gift Hampers and e-gift cards are the perfect answer - and an e-gift card arrives by email instantly, even on Christmas Eve.

Order soon to avoid disappointment.

The Albion Pantry team`,
  },
  {
    key: "easter", label: "Easter treats",
    subject: "Hop into Easter - chocolate eggs and spring treats",
    body: `Easter is on its way, and our Easter shop is now open with chocolate eggs, hot cross bun biscuits and springtime treats from the best British shops.

Send an Easter hamper to someone you love - we'll wrap it, add your message and post it anywhere in the UK.

Order early for Easter delivery, as eggs always go fast.

Happy Easter,
The Albion Pantry team`,
  },
  {
    key: "mothers_day", label: "Mother's Day gifts",
    subject: "Spoil Mum this Mother's Day",
    body: `Mother's Day is coming up - and nothing says thank you quite like a box of luxury chocolate and her favourite biscuits.

Browse our Mother's Day gift shop, build a personalised hamper, or send an e-gift card on the morning of the day itself.

Add gift wrapping and a personal message at checkout and we'll take care of the rest.

With love,
The Albion Pantry team`,
  },
  {
    key: "new_hampers", label: "New hampers",
    subject: "New in: our latest hampers and treats",
    body: `We've just added a fresh batch of treats to the shelves, including new biscuits, chocolate and pantry favourites.

Mix and match them in a Gift Hamper - choose 4, 6 or 8 treats for one fixed price.

Happy shopping,
The Albion Pantry team`,
  },
];
